import { type } from "os";
import Search from "./Search";
import { ISearchProps } from "./type";

export default Search;
export type { ISearchProps };
